export default "__VITE_ASSET__ClZNhwvp__"